
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faStarHalf
} from "@fortawesome/free-solid-svg-icons";

type RatingProps = {
  rating: number;
  numReviews?: number;
};

export default function Rating({
  rating,
  numReviews
}: RatingProps) {
  const validRating = Number.isFinite(rating)
    ? Math.max(0, Math.min(5, rating))
    : 0;

  const hasReviews =
    numReviews !== undefined
      ? numReviews > 0
      : validRating > 0;

  const value = hasReviews ? validRating : 0;

  return (
    <div className="rating">
      {Array.from({ length: 5 }, (_, index) => {
        const difference = value - index;

        const full = difference >= 1;
        const half = difference >= 0.5 && !full;

        return (
          <span key={index}>
            <FontAwesomeIcon
              icon={half ? faStarHalf : faStar}
              style={{
                color: full || half
                  ? "#E3AA19"
                  : "#A0A5AE"
              }}
            />
          </span>
        );
      })}

      <span className="rating-text">
        {!hasReviews
          ? "Sin calificaciones"
          : `${value.toFixed(1)} de 5${numReviews !== undefined
            ? ` (${numReviews} opiniones)`
            : ""
          }`}
      </span>
    </div>
  );
}
